import { useListSelectableItemsQuery } from 'api/ml-service/ml-service';
import AutocompleteField from 'components/forms/fields/autocomplete-field/autocomplete-field.component';
import { useTranslation } from 'react-i18next';

const AddCustomRuleSelectRecommendation = () => {
  const { t } = useTranslation();
  const { data, isLoading } = useListSelectableItemsQuery(null);
  const options = data?.items.map(item => ({
    id: item,
    label: item,
  }));

  return (
    <AutocompleteField
      name="recommendationItemIds"
      label={t('forms.addCustomRuleForm.recommendations.autocomplete.label')}
      multiple
      options={options}
      loading={isLoading}
      data-testid="AddCustomRuleSelectRecommendation.AutocompleteField"
    />
  );
};

export default AddCustomRuleSelectRecommendation;
